import path from 'ramda/src/path'

export default (state, { routeId }) => path(
	['app', routeId, 'modalProps'], state,
)
